import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { grey } from '@material-ui/core/colors';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
// models
import Message from '../models/Message';
import { Option } from '../models/Conversation';
import { motion } from 'framer-motion';





const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
      },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    adi: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      borderRadius:20,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
    },
    button: {
      textTransform: "none",
      borderRadius: '18px',
      padding: '8px 15px',
      background: 'rgba(22,43,117,.1)',
      color: '#162b75',
      border: 'none',
      fontSize: '.75rem',
      fontFamily: 'Arial',
      
      "&:hover":{
        background: '#162b75',
        color: '#fff',
        border: 'none'
      }   
    }
  }));

const QuickResponse = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message
    return (
        <div className={classes.root}>
          <Grid container spacing={1}>
            {message.messageData.map((option:Option, index:number)=>{
              if(option.isNew){
                return ( 
                    <Badge badgeContent="New" color="primary" style={{marginRight: "20px", marginTop:"6px", marginBottom: "6px", marginLeft: "6px"}}>
                      <Grid key={message.messageIndex + option.value} item >
                        <motion.div
                        animate={{opacity:[0,1],x:[0,5,0],
                          rotate:[0,-2,0,2,0]}}
                        transition={{duration:0.3, delay:index*0.1}}
                        >
                          <Button className={classes.button} size="small" key={message.messageIndex + option.value} variant="outlined" color="primary"  onClick={() => props.actions.quickResponseHandler(props.itemIndex,option.label)}>
                          {option.label}
                          </Button>
                        </motion.div>
                      </Grid>   
                    </Badge>
                );
              }
              else {
                return(
                  <Box style={{marginRight: "6px", marginTop:"6px", marginBottom: "6px", marginLeft: "6px"}}>
                    <Grid key={message.messageIndex + option.value} item>
                      <motion.div
                      animate={{opacity:[0,1],x:[0,5,0],
                        rotate:[0,-2,0,2,0]}}
                      transition={{duration:0.3, delay:index*0.1}}
                      >
                        <Button className={classes.button} size="small" key={message.messageIndex + option.value} variant="outlined" color="primary"  onClick={() => props.actions.quickResponseHandler(props.itemIndex,option.label)}>
                        {option.label}
                        </Button>
                      </motion.div>
                    </Grid> 
                  </Box>
                );      
              }
            })}
          </Grid>
        </div>
      );
};

export default QuickResponse;